// build-on-this-page-nav.ts
// Builds the on-this-page nav and returns true if nav was built

export function buildOnThisPageNav({
  mainSelector = '#featured-documents',
  navSelector = '.on-this-page-nav',
  yOffset = -80
} = {}): boolean {

  console.log('[OnThisPageNav] Called with mainSelector:', mainSelector, 'navSelector:', navSelector);
  const mainSection = document.querySelector<HTMLElement>(mainSelector);
  if (!mainSection) {
    console.warn('[OnThisPageNav] Main section not found for selector:', mainSelector);
    return false;
  }

  // Gather all h2 and h3 headings
  const headings = Array.from(mainSection.querySelectorAll<HTMLHeadingElement>('h2, h3'));
  console.log('[OnThisPageNav] Found', headings.length, 'headings in main section.');
  if (headings.length < 2) {
    console.info('[OnThisPageNav] Not enough headings to build nav.');
    return false; // Only build nav if more than one heading
  }

  // Build nav structure: h2 as parent, h3 as child
  let headingCount = 0;
  const navList = document.createElement('ul');
  navList.className = 'on-this-page-nav-list';
  let currentH2Li: HTMLLIElement | null = null;
  let h2Count = 0;
  let h3UnderCurrentH2 = 0;
  let hasMultipleH3 = false;

  headings.forEach((heading, i) => {
    console.log(`[OnThisPageNav] Processing heading #${i + 1}:`, heading.textContent);
    // Extract plain text and sanitize for id
    const headingText = heading.textContent?.trim() || '';
    // Remove quotes, punctuation, and collapse whitespace for id
    const sanitizedIdText = headingText
      .toLowerCase()
      .replace(/['"“”‘’`]/g, '')
      .replace(/<[^>]*>/g, '') // remove any HTML tags (shouldn't be present in textContent, but safe)
      .replace(/[^a-z0-9\s-]/g, '') // keep alphanum, space, dash
      .replace(/\s+/g, '-');
    if (!heading.id) {
      heading.id = 'section-' + (++headingCount) + '-' + sanitizedIdText;
    }
    if (heading.tagName.toLowerCase() === 'h2') {
      h2Count++;
      currentH2Li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = headingText;
      currentH2Li.appendChild(a);
      navList.appendChild(currentH2Li);
      h3UnderCurrentH2 = 0;
    } else if (heading.tagName.toLowerCase() === 'h3') {
      h3UnderCurrentH2++;
      if (h3UnderCurrentH2 > 1) hasMultipleH3 = true;
      if (currentH2Li) {
        let sublist = currentH2Li.querySelector('ul');
        if (!sublist) {
          sublist = document.createElement('ul');
          sublist.className = 'on-this-page-nav-sublist';
          currentH2Li.appendChild(sublist);
        }
        const subli = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = headingText;
        subli.appendChild(a);
        sublist.appendChild(subli);
      }
    }
  });

  // Only show nav if more than one h2/h3, or any h2 has more than one h3 child
  if (h2Count > 1 || hasMultipleH3 || headings.length > 1) {
    const navTarget = document.querySelector(navSelector);
    if (navTarget) {
      console.log('[OnThisPageNav] Building nav and attaching to:', navSelector);
      navTarget.classList.remove('d-none', 'hidden');
      navTarget.appendChild(navList);
      navList.classList.add('list-unstyled', 'chroa-resource-body__sidebar-list');
      navList.querySelectorAll('a').forEach(link => {
        link.classList.add('chroa-resource-body__sidebar-link');
      });
      navList.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const id = this.getAttribute('href')?.substring(1);
          if (id) {
            const target = document.getElementById(id);
            if (target) {
              const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          }
        });
      });
      // Dispatch custom event to signal nav is built
      const navWrapper = document.querySelector('#on-this-page-nav-wrapper');
      if (navWrapper) {
        navWrapper.dispatchEvent(new CustomEvent('onThisPageNavBuilt', { bubbles: false }));
      }
      return true;
    } else {
      console.warn('[OnThisPageNav] Nav target not found for selector:', navSelector);
    }
  } else {
    console.info('[OnThisPageNav] Not enough h2/h3 or h3 children to build nav. h2Count:', h2Count, 'hasMultipleH3:', hasMultipleH3, 'headings.length:', headings.length);
  }
  return false;
}
